// src/components/Result.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Result.css";
import ApiBaseUrl from "../../ApiBaseUrl/ApiBaseUrl.json";

const Result = () => {
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("adminLoggedIn");
    if (!isLoggedIn) {
      navigate("/admin");
      return;
    }

    axios
      .get(`${ApiBaseUrl.ApiBaseUrl}/api/test-results`)
      .then((res) => setResults(res.data))
      .catch((err) => console.error("Failed to fetch results:", err));
  }, []);

  return (
    <div className="result-wrapper">
      <h2>Candidates List</h2>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr style={{backgroundColor:"white"}}>
              <th>Candidate Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Position</th>
              <th>Level</th>
              <th>Score</th>
              <th>Date</th>
              <th>PDF</th>
            </tr>
          </thead>
          <tbody>
            {results.map((r, idx) => (
              <tr key={idx}>
                <td style={{color:"#6941C6"}}>{r.CandidateName}</td>
                <td>{r.Email}</td>
                <td>{r.Phone}</td>
                <td>{r.Language}</td>
                <td>{r.Level}</td>
                <td>
                  {r.Score}/{r.TotalQuestions} (
                  {Math.round((r.Score / r.TotalQuestions) * 100)}%)
                </td>
                <td>{r.SubmittedAt ? new Date(r.SubmittedAt).toLocaleString() : "N/A"}</td>
                <td>
                  {r.ResultPdf ? (
                    <a href={`${ApiBaseUrl.ApiBaseUrl}${r.ResultPdf}`} target="_blank" rel="noopener noreferrer">
                      View PDF
                    </a>
                  ) : (
                    "Not Available"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Result;